import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, Input } from "@angular/core";
import { CsTabButtonBase } from "./cs-tab-button-interface";
import { CsTabComponent } from "./cs-tab";
import { syncButtonNameFromHost } from "directives/cs-capture-cover/host-name-source";

@Component({
    selector: 'cs-tab-button',
    templateUrl: 'cs-tab-button.html',
    host: { 'class': 'tab-button' },
    providers: [{ provide: CsTabButtonBase, useExisting: CsTabButtonComponent }],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CsTabButtonComponent extends CsTabButtonBase {
  @Input() value: any;
  @Input() showNotification: boolean = false;
  @Input() disabled: boolean = false;

  @HostBinding('attr.disabled')
  get disabledAttr(): '' | null {
    return this.disabled ? '' : null;
  }

  constructor(private selectComponent: CsTabComponent,
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef) {
    super();
  }

  ngAfterViewChecked() {
    // the inner <button> is empty, so it takes its name from the tab's drawn text
    syncButtonNameFromHost(this.elementRef, undefined);
  }

  handleClick(ev: Event) {
    void ev;
    if (this.disabled) {
      return;
    }
    this.selectComponent.select(this);
    this.select();
  }

  deselect(): void {
    let element = this.elementRef.nativeElement as HTMLElement;
    element.classList.remove('tab-activated');
    this.cdr.markForCheck();
  }

  getValue(): any {
    return this.value;
  }

  select(): void {
    let element = this.elementRef.nativeElement as HTMLElement;
    element.classList.add('tab-activated');
    this.cdr.markForCheck();
  }
}
